import { ILegacyParserClassTypes, ILegacyBuilderClassTypes } from 'types/graphqlTypes'
import * as yup from 'yup'

export type TConnectionConfigType = 'InboundConnectionConfig' | 'OutboundConnectionConfig'

export const EdiMessageTypeSchema = yup.object({
  /**
   * the inbound/outbound connection config id to associate this ediMessageType with
   * this is paired with connectionConfigType to describe which inbound/outbound config this message type relates to.
   * @example '10'
   */
  connectionConfigId: yup.string(),

  /**
   * whether connectionConfigId refers to an inbound or outbound config.
   * this is paired with connectionConfigId to describe which inbound/outbound config this message type relates to.
   * @example 'InboundConnectionConfig'
   */
  connectionConfigType: yup.string(),

  /**
   * EdiMessageType id to update
   * only used during updates
   * @example '99'
   * */
  id: yup.string().nullable().default(null),

  /**
   * identifies the transaction set & subtype for this ediMessageType
   * value should be created by encodeOptionValue/decodeOptionValue functions from useTransactionSet hook
   * @example '_204'
   * @example '_214::SCHEDULED_TRACKING'
   */
  transactionSetWithSubtype: yup.string().required(),

  /**
   * the self-serve/configurable parser used to parse an inbound message type
   * foreign key to a configurable parser. see useConfigurableParser query
   * empty for outbound message types
   * @example '7'
   */
  ediMapperConfigurableParserId: yup.string().nullable().default(null),

  /**
   * one of our existing legacy parsers (implemented in a ruby class)
   * empty for outbound message types
   * @example Edi_Mapper_Parser_Agco204
   */
  legacyParserClass: yup
    .mixed<'' | ILegacyParserClassTypes>()
    .oneOf(['', ...Object.values(ILegacyParserClassTypes)]),

  /**
   * the self-serve/configurable builder used to create an outbound message type
   * foreign key to a configurable builder. see useConfigurableBuilder query
   * empty for inbound message types
   * @example '7'
   */
  ediMapperConfigurableBuilderId: yup.string().nullable().default(null),

  /**
   * one of our existing legacy EDI builders (implemented in a ruby class)
   * empty for inbound message types
   * @example Edi_Mapper_Builder_Target_RespondToLoadTender990
   */
  legacyBuilderClass: yup
    .mixed<'' | ILegacyBuilderClassTypes>()
    .oneOf(['', ...Object.values(ILegacyBuilderClassTypes)]),
})

export type TEdiMessageTypeSchema = yup.InferType<typeof EdiMessageTypeSchema>
